// video source from
// https://www.pexels.com/video/woman-doing-leg-exercises-2785533/
const live = require("../assets/videos/pexels.com-2785533.mp4");

export default {
  live,
};
